import lookups from '@/assets/json/clientLookups.json'
import { useFormStore } from '@/stores/form'
import { notify } from 'notiwind'
import i18n from '@/i18n/i18n'
import router from '@/router'

const doNotify = (title, text, duration = 6000, group = 'error') => {
  notify(
    {
      group: group,
      title,
      text
    },
    duration
  )
}

export default async function () {
  const formStore = useFormStore()

  const { ADD_A_COMMERCIAL_ACTIVITY } = lookups.establishmentRequestType
  const { foreignBranch } = lookups.establishmentPartnershipType
  const {
    establishmentPartnershipTypeId,
    establishmentRequestRelatedEstablishments,
    establishmentEconomicActivities,
    establishmentRequestTypeId
  } = formStore.form.values

  if (
    !establishmentPartnershipTypeId &&
    !formStore.form.values?.establishmentRequestRelatedPersons?.length
  ) {
    doNotify(i18n.t('warningTitle'), i18n.t('NoRelatedPersonAdded'))
    return false
  }

  if (establishmentPartnershipTypeId) {
    if (
      !formStore.extraMap.isConcernedPersonRequired &&
      !formStore.form.values?.establishmentRequestRelatedPersons?.length
    ) {
      doNotify(i18n.t('warningTitle'), i18n.t('NoRelatedPersonAdded'))
      return false
    }
    if (
      !formStore.extraMap.isConcernedEstablishmentRequired &&
      !establishmentRequestRelatedEstablishments?.length
    ) {
      doNotify(i18n.t('warningTitle'), i18n.t('NoRelatedEstablishmentAdded'))
      return false
    }

    if (
      establishmentPartnershipTypeId == foreignBranch &&
      !establishmentRequestRelatedEstablishments?.length
    ) {
      doNotify(i18n.t('warningTitle'), i18n.t('NoRelatedEstablishmentAdded'))
      return false
    }

    if (
      !formStore.extraMap.isEstablishmentCanBeGroup &&
      establishmentRequestRelatedEstablishments?.length > 1 &&
      !(
        establishmentPartnershipTypeId == foreignBranch &&
        establishmentRequestRelatedEstablishments.length >= 2
      )
    ) {
      doNotify(i18n.t('warningTitle'), i18n.t('OneRelatedEstablishment'))
      return false
    }

    if (
      !formStore.extraMap.isPersonCanBeGroup &&
      formStore.form.values.establishmentRequestRelatedPersons?.length > 1
    ) {
      doNotify(i18n.t('warningTitle'), i18n.t('OneRelatedPerson'))
      return false
    }

    if (
      establishmentRequestTypeId == ADD_A_COMMERCIAL_ACTIVITY &&
      !establishmentEconomicActivities?.length
    ) {
      doNotify(i18n.t('warningTitle'), i18n.t('NoRelatedEconomicActivitiesAdded'))
      return false
    }
  }
  return true
}
